import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";

import IndexTable from "../../components/Layout/IndexTable";
import { PromoContext } from "../../context";
import Permissions from "../../permissions";
import usePromoColumns from "./usePromoColumns";

const PromoDisplay = ({ handleChangeTab }) => {
  const { t } = useTranslation();
  const { promoType } = useParams();
  const { promoCodes, promoCodesCount, searchPromoCodes } = useContext(PromoContext);
  const columns = usePromoColumns(promoType, () => handleChangeTab(1));

  const fetchPromoCodes = async ({ ordering, search, page, page_size }) =>
    searchPromoCodes(promoType, search, ordering, page_size, page);

  return (
    <IndexTable
      muiTableProps={{
        size: "small",
        stickyHeader: true,
      }}
      columns={columns}
      rows={promoCodes}
      totalRowsCount={promoCodesCount}
      fetchResource={fetchPromoCodes}
      fetchResourceDeps={[promoType]}
      searchProps={{
        placeholder: `${t("Promos.PromoSearch.Search")} ${t(`Promos.Nav.${promoType}`)} ${t(
          "Promos.PromoSearch.Codes",
        )}`,
      }}
      createPath="/promos/new"
      createPerms={[Permissions.readPromos, Permissions.writePromos]}
      createButtonText={t("Promos.Table.CreateCode")}
      defaultSortBy="expired"
      defaultSortDir="desc"
    />
  );
};

PromoDisplay.propTypes = {
  handleChangeTab: PropTypes.func.isRequired,
};

export default PromoDisplay;
